import { render } from "./Plate.vue?vue&type=template&id=9da8a004"
import script from "./Plate.vue?vue&type=script&lang=js"
export * from "./Plate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__